import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from 'api/baseApi';
import authReducer from 'features/auth/authSlice';
import transportOrderDetailReducer from 'features/transport-order-detail/transportOrderDetailSlice';

export const rootReducer = combineReducers({
    auth: authReducer,
    transportOrderDetail: transportOrderDetailReducer,
    [baseApi.reducerPath]: baseApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const apiMiddleware = [baseApi.middleware];
